import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Invoice} from '../../core/_models'
import {isPOS, KTIcon} from '../../../../../../../_metronic/helpers'
import clsx from 'clsx'
import {PaymentPos} from './paymentPos'
import {PaymentCash} from './paymentCash'
import {PaymentCard} from './paymentCard'
import {useAuth} from '../../../../../auth'
import {PaymentOnline} from './paymentOnline'
import {useQuery} from 'react-query'
import {getInvoicePaymentOptions} from '../../../../../online-payment/core/onlinePaymentApi'
import {hidesPayments} from '../../../../../install-app/core/androidApp'

type Props = {
  invoice: Invoice
  setShowPaymentModal: Dispatch<SetStateAction<boolean>>
}

const PaymentModal: FC<Props> = ({invoice, setShowPaymentModal}) => {
  const {currentUser} = useAuth()
  // The online tab follows the business's online payment settings (every configured gateway).
  const onlineOptions = useQuery(
    ['online-payment-options', invoice.hsh || ''],
    () => getInvoicePaymentOptions(invoice.hsh || ''),
    {enabled: !!invoice.hsh, retry: false, refetchOnWindowFocus: false}
  )
  // No online payment in the Bazaar and Myket builds of the Android app.
  const onlineEnabled = !!onlineOptions.data?.enabled && !hidesPayments()
  const [tab, setTab] = useState(
    currentUser && currentUser.cpl && currentUser.cpl.findIndex((x) => x.id == invoice.slid) > -1
      ? isPOS
        ? 0
        : 1
      : 3
  )

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])
  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_product'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered modal-lg modal-fullscreen-sm-down'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <div className='modal-header'>
              {/* begin::Modal title */}
              <h2 className='fw-bolder'>پرداخت</h2>
              {/* end::Modal title */}

              {/* begin::Close */}
              <div
                className='btn btn-icon btn-sm btn-active-icon-primary'
                data-kt-products-modal-action='close'
                onClick={() => {
                  setShowPaymentModal(false)
                }}
                style={{cursor: 'pointer'}}
              >
                <KTIcon iconName='cross' className='fs-1' />
              </div>
              {/* end::Close */}
            </div>
            {/* begin::Modal body */}
            <div className='modal-body scroll-y'>
              <div className='btn-group w-100 shadow' role='group'>
                {isPOS &&
                  currentUser &&
                  currentUser.cpl &&
                  currentUser.cpl.findIndex((x) => x.id == invoice.slid) > -1 && (
                    <button
                      type='button'
                      className={clsx('btn btn-light-primary', {active: tab == 0})}
                      onClick={() => {
                        setTab(0)
                      }}
                    >
                      <span className={clsx({'fw-bolder': tab == 0})}>کارت خوان</span>
                    </button>
                  )}
                {currentUser &&
                  currentUser.cpl &&
                  currentUser.cpl.findIndex((x) => x.id == invoice.slid) > -1 && (
                    <>
                      <button
                        type='button'
                        className={clsx('btn btn-light-primary', {active: tab == 1})}
                        onClick={() => {
                          setTab(1)
                        }}
                      >
                        <span className={clsx({'fw-bolder': tab == 1})}>کارت به کارت</span>
                      </button>
                      <button
                        type='button'
                        className={clsx('btn btn-light-primary', {active: tab == 2})}
                        onClick={() => {
                          setTab(2)
                        }}
                      >
                        <span className={clsx({'fw-bolder': tab == 2})}>نقدی</span>
                      </button>
                    </>
                  )}
                {onlineEnabled && (
                  <button
                    type='button'
                    className={clsx('btn btn-light-primary', {active: tab == 3})}
                    onClick={() => {
                      setTab(3)
                    }}
                  >
                    <span className={clsx({'fw-bolder': tab === 3})}>پرداخت آنلاین</span>
                  </button>
                )}
              </div>
              <div className='card mt-7 pt-5'>
                {tab == 0 && isPOS && (
                  <PaymentPos invoice={invoice} setShowPaymentModal={setShowPaymentModal} />
                )}
                {tab == 1 && (
                  <PaymentCard invoice={invoice} setShowPaymentModal={setShowPaymentModal} />
                )}
                {tab == 2 && (
                  <PaymentCash invoice={invoice} setShowPaymentModal={setShowPaymentModal} />
                )}
                {tab == 3 && onlineEnabled && (
                  <PaymentOnline invoice={invoice} setShowPaymentModal={setShowPaymentModal} />
                )}
              </div>
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {PaymentModal}
